import { environment } from '../../environments/environment';
import { SupabaseFileService } from './supabase-file.service';
import { LocalFileService } from './local-file.service';

export abstract class FileService {
  /**
   * Generic method that loads a file from a given bucket and path
   * @param bucket
   * @param path
   */
  abstract getFile(bucket: string, path: string): Promise<Blob | null>;

  /**
   * Loads an asset from the current active tenant by path
   * @param path
   */
  abstract getAsset(path: string): Promise<Blob | null>;

  /**
   *
   * @param bucket
   * @param path
   */
  abstract getUrl(bucket: string, path: string): Promise<string | null>;
}

export function storageProviderFactory(): FileService {
  if (environment.storage === 'supabase') {
    return new SupabaseFileService();
  } else {
    return new LocalFileService();
  }
}
